import React from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {sentenceCase} from '../../../utils'


const cssStyles = ({ count, margin }) => ({
  root: css`
    width: 100%;
    color: red;
    list-style: ${count === 1 ? 'none' : 'disc'};
    margin: ${margin || '10px 0'};
    background-color: rgba(255, 0, 0, 0.1);
    padding: 15px;
    padding-left: ${count === 1 ? '15px' : '30px'};
    border-radius: 4px;
  `,
  text: css`
    font-size: 0.9rem;
    letter-spacing: -0.02rem;
    line-height: 1.2;
  `
})


const Errors = ({ errors, margin, ...props }) => {
  if (!errors) return null

  // Normalize everything into an array of messages
  let list = []

  if (typeof errors === 'string') {
    list = [errors]
  } else if (Array.isArray(errors)) {
    list = errors
  } else if (typeof errors === 'object') {
    // { field: 'msg' } or { field: ['msg1','msg2'] }
    for (const [field, value] of Object.entries(errors)) {
      if (Array.isArray(value)) {
        value.forEach(msg => {
          list.push(`${sentenceCase(field)} ${msg}`)
        })
      } else {
        list.push(`${sentenceCase(field)} ${value}`)
      }
    }
  }

  const count = list.length
  const styles = cssStyles({ count, margin })

  if (count === 0) return null

  return (
    <ul css={styles.root} {...props}>
      {list.map((msg, i) => (
        <li key={i}>
          <p css={styles.text}>{sentenceCase(msg)}</p>
        </li>
      ))}
    </ul>
  )
}


export default Errors